module.exports = __webpack_public_path__ + "assets/chevron-up.d053e04f.svg";